import request from '@/utils/service'

// 设备列表
export function getSuperviseDevices(data) {
  return request({ url: '/superviseDevice/list', params: data })
}

// 设备重启
export function restartFireDevice(data) {
  return request({ url: '/superviseDevice/restartFireDevice', data })
}

// 绑定监控设备
export function bandMonitorDevices(data) {
  return request({ url: '/superviseDevice/bandMonitorDevices', data })
}

// 绑定消防设备
export function bandFireDevices(data) {
  return request({ url: '/superviseDevice/bandFireDevices', data })
}

// 设备解绑
export function unbandDevice(data) {
  return request({ url: '/superviseDevice/unbandDevice', data })
}

// 手动添加消防设备告警
export function setSuperviseDeviceAlarm(data) {
  return request({ url: '/superviseDeviceAlarm/add', data })
}
